import { Cluster } from './cluster';

export const CAMPUSES = {
    VA: 'VA',
    IL: 'IL'
};

export class Campus {
    id: number;
    location: string;
    clusters: Cluster[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/campus.ts